/**
 * 议程编辑器
 *
 */

'use strict'

import Vue from 'vue';
import Component from "vue-class-component";
import { iStorage, iValidator } from 'smart-core-util';
@Component
class sessionEditor extends Vue {

	model = {
		miceId: null,
		dtOn: null, //日期
		timeStart: null, //开始时间
		timeEnd: null, //结束时间
		topic: null, //主题
		place: null, //地点
		content: null, //会议内容
		speaker:null,//讲者姓名
		speakerTimeStart:null,//讲授开始时间
		speakerTimeEnd:null,//讲授结束时间
		discussionGuests:null,//讨论嘉宾
	}
	validModel = {
		dtOn: null, //日期
		timeStart: null, //开始时间
		timeEnd: null, //结束时间
		topic: null, //主题
		place: null, //地点
		content: null //会议内容
	}

	get proposalId() {
		return iStorage.get("proposalId");
	}

	async created() {
		this.model.miceId = this.proposalId;
	}

	/**
	 * 1-校验
	 * 2-保存
	 * 3-
	 */
	async saveAsync({
		onSuccess,
		toast
	}) {
		this.mapper(this.validModel, this.model);
		if(!new iValidator().simpleValidate({
				model: this.validModel,
				toast: toast
			}))
			return;
		var result = await this.api.post(this.url.session.save, this.model); {
			if(result && result.success) {
				onSuccess(result);
			}
		};
	}

	mapper(target, source) {
		Object.keys(target).forEach(function(key) {
			target[key] = source[key];
		})
	}

	//新验证规则
	verifyMthod(toast, modelForm){
		//验证非讲者信息必填项
		this.mapper(this.validModel, modelForm);
		if(!new iValidator().simpleValidate({
			model: this.validModel,
			toast: toast
		})){
			return false;
		}
		//验证讲者信息是否完整,要么都不写,要么都要写
		let speakerForm = {
			speaker:modelForm.speaker,
			speakerId:modelForm.speakerId,
			speakerTimeStart:modelForm.speakerTimeStart,
			speakerTimeEnd:modelForm.speakerTimeEnd
		}
		let speakerValues = Object.values(speakerForm).filter((ele)=>{
			return ele;
		})
		if(speakerValues.length > 0 && speakerValues.length < 4){
			if(toast){
				toast('讲者信息填写不完整')
			}else{
				this.$message.error('讲者信息填写不完整');
			}
			return false;
		}
		return true;
	}

	//根据新需求,改为批量保存
	async saveAllAsync({
		onSuccess,
		toast,
		data,
		hasSpeaker
	}) {
		if(hasSpeaker){
			// if(verifyData.length < 1){
			// 	if(toast){
			// 		toast('当前会议存在讲者,请确保至少有一条日程包含讲者信息')
			// 	}else{
			// 		this.$message.error('当前会议存在讲者,请确保至少有一条日程包含讲者信息');
			// 	}
			// 	return false;
			// }
		}
		let response = await this.api.post(this.url.session.save, data);
		if(response && response.success){
			onSuccess(response);
		}else{

		}
	}
}

export default sessionEditor;



// WEBPACK FOOTER //
// ../scripts/components/sessionEditor.js